import Model from '../models/model';

const model = new Model({
	name: 'Location',
	defaultSort: 'LocationName',
	formTitleField: 'LocationName',
	title: 'Location',
	showGridRefreshBtn: true,
	columns: [{ field: 'LocationName', width: 200, required: true, minLength: 2, maxLength: 50 }]
});

export default model.createFormBase();

